import React from 'react';
import {Link, Route, Switch, withRouter} from 'react-router-dom';
import Helmet from "react-helmet";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import createLink from "../../../libs/createLink";

import {
    fetchMediaCommentsModeration,
    resetMediaCommentsModeration
} from "../../../creators/user.comments.moderation.media";
import {
    fetchArticleCommentsModeration,
    resetArticleCommentsModeration
} from "../../../creators/user.comments.moderation.article";

import Title from "../../components/Title";
import ItemModeration from "./components/ItemModeration";
import {config} from "../../../config";
import Badge from "../../components/badge";


class Moderation extends React.Component {
    constructor(props) {
        super(props);
        this.filter = {
            page: 1,
            limit: 28,
        };
        this.props.fetchMediaCommentsModeration();
        this.props.fetchArticleCommentsModeration();
    }

    render() {
        return (
            <div id="moderation">
                <Helmet>
                    <title>{config.preTitle}Modération des commentaires{config.postTitle}</title>
                </Helmet>
                <div className="container">
                    <div className="card big">
                        <Title heading={"heading-2"} display={"display-2"}>Nouveau contenu à modérer</Title>
                        <div className="layout-sidebar">
                            <div className="sidebar">
                                <ul className="sidebar-menu">
                                    <Link to={createLink('commentsModeration')}
                                          className={`${this.props.location.pathname === createLink('commentsModeration') ? 'active' : ''} side-menu-item`}>
                                        Photo / Vidéo {this.props.mediaCommentsInitialized && <Badge btnStyle={this.props.mediaCommentsTotal >= 1 ? "red-reverse" : "primary"}
                                                                                                     content={this.props.mediaCommentsTotal} />}
                                    </Link>
                                    <Link to={createLink('commentsModerationArticles')}
                                          className={`${this.props.location.pathname === createLink('commentsModerationArticles') ? 'active' : ''} side-menu-item`}>
                                        Articles {this.props.articleCommentsInitialized && <Badge btnStyle={this.props.articleCommentsTotal >= 1 ? "red-reverse" : "primary"}
                                                                                                  content={this.props.articleCommentsTotal} />}
                                    </Link>
                                    {/*<Link to={createLink('commentsModerationStatus')}*/}
                                    {/*      className={`${this.props.location.pathname === createLink('commentsModerationStatus') ? 'active' : ''} side-menu-item`}>*/}
                                    {/*    Status*/}
                                    {/*</Link>*/}
                                </ul>
                            </div>
                            <div className="main-wrapper">
                                <Switch>
                                    <Route path={`${createLink('commentsModeration')}`} exact
                                           render={(props) => <ItemModeration parentKind={"medias"} />}/>
                                    <Route path={`${createLink('commentsModerationArticles')}`} exact
                                           render={(props) => <ItemModeration parentKind={"articles"} />}/>
                                    {/*<Route path={`${createLink('commentsModerationStatus')}`} exact*/}
                                    {/*       render={(props) => <ItemModeration parentKind={"status"} />}/>*/}
                                    {/*w*/}
                                </Switch>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        mediaCommentsInitialized: state.mediaCommentsModeration.initialized,
        mediaCommentsTotal: state.mediaCommentsModeration.total,

        articleCommentsInitialized: state.articleCommentsModeration.initialized,
        articleCommentsTotal: state.articleCommentsModeration.total,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchMediaCommentsModeration,
    resetMediaCommentsModeration,

    fetchArticleCommentsModeration,
    resetArticleCommentsModeration,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Moderation));